import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import {
  PaginatedResult,
  AssociateUsersRequest,
  AddAssociateUserRequest,
  UpdateAssociateUserRequest,
  DeleteAssociateUserRequest
} from './types';
/**
 * --------------------------------------------------
 *	User HTTP Serice
 * --------------------------------------------------
 **/
export const AssociateUserService = {
  async getAssociateUsers(
    associateUsersRequest: AssociateUsersRequest
  ): Promise<PaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ASSOCIATE_USERS(
        associateUsersRequest.orgId,
        associateUsersRequest.page,
        associateUsersRequest.limit,
        associateUsersRequest.searchKeyword
      )
    );
    return data;
  },
  async postAssociateUsers(
    addAssociateUsersRequest: AddAssociateUserRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_ASSOCIATE_USERS(addAssociateUsersRequest.orgId),
      addAssociateUsersRequest
    );
    return data;
  },
  async putAssociateUsers(
    updateAssociateUsersRequest: UpdateAssociateUserRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.put(
      endpoint.PUT_ASSOCIATE_USERS(
        updateAssociateUsersRequest.orgId,
        updateAssociateUsersRequest.associateId
      ),
      updateAssociateUsersRequest
    );
    return data;
  },
  async deleteAssociateUsers(
    deleteAssociateUsersRequest: DeleteAssociateUserRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_ASSOCIATE_USERS(
        deleteAssociateUsersRequest.orgId,
        deleteAssociateUsersRequest.associateId
      )
    );
    return data;
  }
};
